
<template>
    <div class="slider slider6">
        <div class="m6-swiper">
            <swiper :options="options" ref="swiper">
                <swiper-slide v-for="i in 5" :key="i">
                    <div>
                        <div :class="`m6-img img${i}`"></div>
                        <div class="vd cursor">

                            <video class="vd-video" muted autoplay loop
                                :src="`https://resource-mp4.ujoygames.com/qyhx/pet/video_pet_${i}.mp4`"></video>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-pagination swiper-pagination-silder6  cursor
            position-absolute " slot="pagination"></div>
        </div>
        <div class="fv"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            options: {
                grabCursor: true, //在轮播图上显示小手
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    waitForTransition: false,
                },
                effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
                pagination: {
                    el: ".swiper-pagination-silder6",

                    touchRatio: 1, //解决滑动卡顿
                    longSwipesRatio: 0.1,
                    threshold: 10, //如果触摸距离小于该值滑块不会被拖动
                    followFinger: false,
                    bulletClass: "my-bullet", //需设置.my-bullet样式
                    clickable: true, // 允许点击小圆点跳转
                    renderBullet: function (index, className) {
                        switch (index) {
                            case 0:
                                name = "";
                                break;
                            case 1:
                                name = "";
                                break;
                            case 2:
                                name = "";
                            case 3:
                                name = "";
                            case 4:
                                name = "";
                            default:
                                name = "";
                        }
                        return (
                            '<div class="' +
                            className +
                            " " +
                            className +
                            [index] +
                            '"><i>' +
                            name +
                            "</i></div>"
                        );
                    },
                },
            }

        }


    }
}
</script>
<style lang="scss" scoped>
.slider6 {
    background: url("../../assets/img/m6/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;

    .fv {
        background: url("../../assets/img/m6/fv.png") no-repeat top;
        background-size: cover;
        width: 1136px;
        height: 104px;
        position: absolute;
        right: 293px;
        top: 840px;
    }

    .m6-swiper {
        position: absolute;
        // right: 260px;
        // top: 105px;
        // width: 1160px;
        // height: 680px;
        width: 1920px;
        height: 1080px;

        .swiper-container {
            // width: 1160px;
            // height: 680px;
            width: 1920px;
            height: 1080px;

            .vd {

                background: url("../../assets/img/m6/vd.png") center top;
                background-size: 100% 100%;
                width: 369px;
                height: 220px;
                position: absolute;
                left: 369px;
                top: 585px;
                display: flex;
                align-items: center;
                justify-content: center;

                .vd-video {
                    // width: 100%;
                    // height: 100%;
                    width: 354px;
                    height: 199px;
                }
            }

            .m6-img {
                // width: 1160px;
                // height: 680px;
                width: 1920px;
                height: 1080px;
            }

            .img1 {
                background: url("../../assets/img/m6/play1.png") no-repeat center center / 100%;
            }

            .img2 {
                background: url("../../assets/img/m6/play2.png") no-repeat center center / cover;
            }

            .img3 {
                background: url("../../assets/img/m6/play3.png") no-repeat center center / cover;
            }

            .img4 {
                background: url("../../assets/img/m6/play4.png") no-repeat center center / cover;
            }

            .img5 {
                background: url("../../assets/img/m6/play5.png") no-repeat center center / cover;
            }


        }

        /deep/ .swiper-pagination-silder6 {
            width: 550px !important;
            height: 80px;
            display: flex;
            justify-content: space-between;
            position: absolute;
            right: 380px;
            top: 710px;

            .swiper-pagination-bullet-active {
                background: transparent;
            }

            .my-bullet {

                i {
                    display: block;
                    width: 106px;
                    height: 106px;
                }
            }

            // 选中后的按钮图
            .my-bullet0.swiper-pagination-bullet-active i {
                background: url("../../assets/img/m6/btn1-active.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet0 i {
                background: url("../../assets/img/m6/btn1.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet1.swiper-pagination-bullet-active i {
                background: url("../../assets/img/m6/btn2-active.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet1 i {
                background: url("../../assets/img/m6/btn2.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet2.swiper-pagination-bullet-active i {
                background: url("../../assets/img/m6/btn3-active.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet2 i {
                background: url("../../assets/img/m6/btn3.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet3.swiper-pagination-bullet-active i {
                background: url("../../assets/img/m6/btn4-active.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet3 i {
                background: url("../../assets/img/m6/btn4.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet4.swiper-pagination-bullet-active i {
                background: url("../../assets/img/m6/btn5-active.png") center top;
                background-size: 100% 100%;
            }

            .my-bullet4 i {
                background: url("../../assets/img/m6/btn5.png") center top;
                background-size: 100% 100%;
            }
        }

    }

}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .slider6 {
        .m6-swiper {
            top: -35px !important;

        }

        .m6-img {
            // width: 986px !important;
            // height: 578px !important;
            width: 1728px !important;
            height: 972px !important;
            margin: 0 auto;
        }

        .vd {
            width: 314px !important;
            height: 184px !important;
            top: 520px !important;
            left: 420px !important;

            .vd-video {
                width: 300px !important;
                height: 170px !important;
            }
        }

        .swiper-pagination-silder6 {
            right: 260px !important;
            top: 620px !important;
        }

        .fv {

            width: 966px !important;
            height: 88px !important;
            top: 650px !important;
        }

    }


}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider6.vue